// THE FAMILIES A FIRM MAY CHOOSE, IN ONE PLACE.
//
// Three readers had three opinions before this file existed: the picker in
// SettingsView listed five families, App.tsx's injector knew four (Nunito Sans
// was in neither), and src/App.css imported two from Google. A family could be
// offered and never downloaded, or downloaded and never offered, and nothing
// said so. Now the picker renders APP_FONTS, the stored preference is resolved
// through normaliseAppFont, and scripts/fetch-fonts.js puts a face on disk for
// each — public/fonts/NOTICE records what and under which licence.
//
// Inter, Roboto and Source Sans Pro were dropped 2026-08-16 when the fonts
// stopped coming from a CDN. A stored preference naming one of them resolves to
// DM Sans on the next read: an unmatched value in a <select> does not render
// blank, it silently displays the FIRST option while the stored value stays put,
// which is how a person ends up looking at a font the app is not using.

/** The system stack — a fallback chain of LOCAL font names; nothing is fetched. */
export const SYSTEM_FONT = "System default";
export const SYSTEM_FONT_STACK =
  "-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif";

export const DEFAULT_APP_FONT = "DM Sans";

/**
 * What the Settings picker offers, in the order it offers it. Every entry other
 * than SYSTEM_FONT must have @font-face rules in src/fonts.css and a file in
 * public/fonts/ — `node scripts/fetch-fonts.js` is what puts them there.
 */
export const APP_FONTS: readonly string[] = [
  DEFAULT_APP_FONT,
  "Nunito Sans",
  SYSTEM_FONT,
];

/**
 * A stored preference, resolved to something this build can actually render.
 * Anything unrecognised — a family since dropped, a typo, an absent value —
 * becomes the default rather than a `font-family` naming a face no browser has.
 */
export function normaliseAppFont(v: unknown): string {
  return typeof v === "string" && APP_FONTS.includes(v) ? v : DEFAULT_APP_FONT;
}

/** The `font-family` value for a chosen family. */
export function appFontStack(name: string): string {
  return name === SYSTEM_FONT ? SYSTEM_FONT_STACK : `'${name}',sans-serif`;
}
